import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserDetails } from "../../services/apiRequest";
import { checkIfIsRoyalInternational } from "../../utilities/helper";

const userDetails = getUserDetails();
const initialState = {
    value: checkIfIsRoyalInternational(userDetails?.user_details?.travel_agency_uid) ? 
    {
        first_name: "",
        last_name: "",
        year: "",
        month: [],
        customer_type: "",
        region: [],
        departure_port_uid: [],
        // duration: "",
        duration: [],
        language: "",
    } : 
    {
        customer_name: "",
        year: "",
        month: [],
        customer_type: "",
        region: [],
        departure_port_uid: [],
        // duration: "",
        duration: [],
        language: "",
    },
    results: [],
    nordicLanguage: "",
    requireSupport: "",
    status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("buildMyHoliday/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const buildMyHolidaySlice = createSlice({
    name: "buildMyHoliday",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addBuildMyHolidayData: (state, action) => {
            state.value = action.payload;
        },
        addBuildMyHolidayResults: (state, action) => {
            state.results = action.payload;
        },
        addNordicLanguage: (state, action) => {
            state.nordicLanguage = action.payload;
        },
        addRequireSupport: (state, action) => {
            state.requireSupport = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const {
    addBuildMyHolidayData,
    addBuildMyHolidayResults,
    addNordicLanguage,
    addRequireSupport,
} = buildMyHolidaySlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.buildMyHoliday.value)`
export const selectBuildMyHoliday = (state) => state.buildMyHoliday.value;
export const selectBuildMyHolidayResults = (state) => state.buildMyHoliday.results;
export const selectNordicLanguage = (state) => state.buildMyHoliday.nordicLanguage;
export const selectRequireSupport = (state) => state.buildMyHoliday.requireSupport;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const clearBuildMyHolidayData = () => (dispatch, getState) => {
    localStorage.removeItem("buildMyHoliday");
    dispatch(
        addBuildMyHolidayData( checkIfIsRoyalInternational(userDetails?.user_details?.travel_agency_uid) ? 
        {
            first_name: "",
            last_name: "",
            year: "",
            month: [],
            customer_type: "",
            region: [],
            departure_port_uid: [],
            // duration: "",
            duration: [],
            language: "",
        } : 
        {
            customer_name: "",
            year: "",
            month: [],
            customer_type: "",
            region: [],
            departure_port_uid: [],
            // duration: "",
            duration: [],
            language: "",
        })
    );
    dispatch(addNordicLanguage(""));
    dispatch(addRequireSupport(""));
};

export default buildMyHolidaySlice.reducer;
